import { AitHeaderRowData, AitRowData } from "aic";
import { removeStylesFromCell } from "./removeStylesFromCell";

/**
 * Removes Optional and Notes styles from a row (and its cells).
 * Processes each cell in the row independently.
 * Works for both regular rows and header rows.
 *
 * Note: External singles with styles are NOT applied here. They should be promoted to
 * TLF-level singles separately (see RemoveStylesModal for reference).
 *
 * @template T - Content type for table cells
 * @template R - Row type (either AitRowData or AitHeaderRowData)
 * @param row - The row to process (can be a regular row or header row)
 * @returns A new row with styles removed from all cells
 */
export const removeStylesFromRow = <T, R extends AitRowData<T> | AitHeaderRowData<T>>(
  row: R,
): R => {
  return {
    ...row,
    cells: row.cells.map((cell) => removeStylesFromCell(cell)),
  } as R;
};
